export default __webpack_public_path__ + "static/screenFifthSectionUkBig-91a934d2ef3e0326614abc35faca33f2.webp";